import * as stylex from "@stylexjs/stylex";
import { ChevronRight } from "lucide-react";
import { copy } from "@/copy";
import { ambientSummary } from "@/domain/idle";
import { type AccountSettings, IDLE_MINUTES, NOTE_DAYS } from "@/domain/schemas";
import "@/theme/tokens.stylex";
import { colors, radii, space } from "@/theme/tokens.stylex";
import "@/theme/type.stylex";
import { type } from "@/theme/type.stylex";
import { ColorBlock } from "@/ui/ColorBlock";
import { Eyebrow } from "@/ui/Eyebrow";
import { Icon } from "@/ui/Icon";
import { press } from "@/ui/press";
import { SwitchSliderTile } from "./SwitchSliderTile";
type ScreenOptionsProps = {
  settings: AccountSettings;
  onChange: (change: Partial<AccountSettings>) => void;
  onOpenAmbient: () => void;
};
const styles = {
  block: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    kOIVth: "x1ur044a",
    $$css: true
  },
  tile: {
    kzqmXN: "xh8yej3",
    kAzted: "x1qafhyn",
    k1xSpc: "x78zum5",
    kjj79g: "x1qughib",
    kGNEyG: "x6s0dn4",
    kOIVth: "x1hu4l6k",
    kMzoRj: "xc342km",
    kWkggS: "xh540kj",
    kaIpWk: "x1fv5t7x",
    k8WAf4: "x1xckggx",
    kg3NbH: "x17qtykl",
    kB7OPa: "x9f619",
    kMv6JI: "x17jlq2w",
    kMwMTN: "x1a11ngh",
    k9WMMc: "x1yc453h",
    kkrTdU: "x1ypdohk",
    $$css: true
  }
};
export function ScreenOptions({
  settings,
  onChange,
  onOpenAmbient
}: ScreenOptionsProps) {
  const text = copy.settings;
  return <ColorBlock tone="soft" padding="clamp(20px, 2.4vw, 32px)" xstyle={styles.block}>
      <div className="x78zum5 xdt5ytf x1v2ro7d">
        <Eyebrow>{text.schedule}</Eyebrow>
        <AmbientTile settings={settings} onOpenAmbient={onOpenAmbient} />
      </div>
      <SwitchSliderTile text={text.idle} range={IDLE_MINUTES} on={settings.idleTimeout.on} value={settings.idleTimeout.minutes} onChange={(on, minutes) => onChange({
      idleTimeout: {
        on,
        minutes
      }
    })} />
      <SwitchSliderTile text={text.noteExpiry} range={NOTE_DAYS} on={settings.noteExpiry.on} value={settings.noteExpiry.days} onChange={(on, days) => onChange({
      noteExpiry: {
        on,
        days
      }
    })} />
    </ColorBlock>;
}
function AmbientTile({
  settings,
  onOpenAmbient
}: Omit<ScreenOptionsProps, "onChange">) {
  const text = copy.settings.ambient;
  return <button type="button" onClick={onOpenAmbient} {...stylex.props(styles.tile, press.scale)}>
      <span className="x78zum5 xdt5ytf xt4j9g6 xeuugli">
        <span className="x1iig92y xhxcbl2 x1hrmo45 x1u7k74">{text.title}</span>
        <span className="x14c3fy2 x1dld7ex x37zpob x1fzhlzt">
          {text.summary(ambientSummary(settings.ambient, settings.clock))}
        </span>
      </span>
      <Icon icon={ChevronRight} size={22} />
    </button>;
}